<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible="visible"
    title="支付确认"
    append-to-body
    width="65rem"
    @open="open"
    :show-close="false"
    :top="medSellteInfo ? '4vh' : '15vh'"
  >
    <el-skeleton v-if="loading" animated />
    <el-main v-if="reg" style="padding: 0px; margin-top: -1rem">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="reg">
          <template slot="title">
            <span style="font-weight: bold; margin-left: 15px; font-size: 1rem"
              >患者信息</span
            >
          </template>
          <el-row type="flex" justify="space-around">
            <el-descriptions
              title=""
              :column="1"
              style="width: 30%"
              :contentStyle="{ color: 'orange' }"
            >
              <el-descriptions-item label="姓名">{{
                reg.patientName
              }}</el-descriptions-item>
              <el-descriptions-item label="性别"
                >{{ reg.patientGender | dictText("Gender")
                }}<span class="left-pad" style="color: gray">年龄: </span
                ><span class="left-pad">{{
                  reg.patientAge
                }}</span></el-descriptions-item
              >
              <el-descriptions-item label="类别">{{
                reg.opType
              }}</el-descriptions-item>
              <el-descriptions-item label="证件">{{
                reg.cardType | dictText("IdType")
              }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions
              v-if="payment"
              title=""
              :column="1"
              style="width: 30%"
              contentClassName="right"
              :contentStyle="{ color: 'red' }"
            >
              <el-descriptions-item label="费用合计">{{
                payment.feeAmount | fmtFloat(2)
              }}</el-descriptions-item>
              <el-descriptions-item label="医保基金支付">{{
                payment.feeFund | fmtFloat(2)
              }}</el-descriptions-item>
              <el-descriptions-item label="医保个人账户">{{
                payment.feeAccount | fmtFloat(2)
              }}</el-descriptions-item>
              <el-descriptions-item label="现金支付">{{
                payment.feeCash | fmtFloat(2)
              }}</el-descriptions-item>
            </el-descriptions>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="med_setl" v-if="medSellteInfo">
          <template slot="title">
            <span style="font-weight: bold; margin-left: 15px; font-size: 1rem"
              >医保结算信息</span
            >
          </template>
          <pre-account :setlinfo="medSellteInfo"></pre-account>
        </el-collapse-item>
      </el-collapse>

      <!-- <el-tag v-if="reg.opType != '自费'" type="info" effect="plain" style="width: 100%">医保交易流水号：{{ payment.insuranceSerialNo }}
      </el-tag> -->
      <el-divider />
      <el-row style="margin-top: 1rem">
        <el-col :span="12">
          <div class="flex">
            <span>支付方式：</span>
            <el-select
              :disabled="paywayable"
              v-model="payWay"
              auto-first
              class="edit-input"
              size="small"
              @change="payWayChange"
              style="width: 140px"
            >
              <el-option
                v-for="item in payWayOptions"
                :key="item.code"
                :label="item.text"
                :value="item.code"
                :disabled="item.disabled"
              />
            </el-select>
          </div>
          <div v-if="payWay === 'sunway'" class="flex">
            <span>授权码:</span>
            <el-input
              style="width: 140px"
              size="small"
              v-model="payCode"
              v-on:keyup.enter.native="settle"
            ></el-input>
          </div>
          <div
            v-if="payWay !== 'enterprise' && !payWay.startsWith('PW07')"
            class="flex"
          >
            <span>折扣比例：</span>
            <dict-selector
              :disabled="payment.ifInsurancePaid"
              size="small"
              style="width: 140px"
              v-model="rebateType"
              dict-type="RebateType"
              placeholder="折扣比例"
              @change="rebateTypeChange"
            />
          </div>
          <div v-if="payWay == 'cash'" class="flex">
            <span>实收(元):</span>
            <el-input
              :oninput="(cash = String(cash).replace(/[^0-9.]/g, ''))"
              style="width: 140px"
              size="small"
              v-model="cash"
              v-on:keyup.enter.native="settle"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <span class="sub-title">应付款</span><br />
            <strong v-if="!loading" class="red medium"
              >￥{{ payment.feeCash | fmtFloat(2) }}</strong
            >
          </div>
          <div v-if="payWay == 'cash'" class="flex">
            <span>找零:</span>
            <strong v-if="!loading" class="orange mini">{{ change }}</strong>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-alert v-if="loading" :closable="false" type="info" center
          >计算中 ... <i class="el-icon-loading"></i>
        </el-alert>
        <el-alert v-if="paying" :closable="false" type="warning" center
          >支付中 ... <i class="el-icon-loading"></i>
        </el-alert>
        <el-alert v-if="err" :closable="false" type="error" center>{{
          err
        }}</el-alert>
      </el-row>
    </el-main>
    <el-row slot="footer" type="flex" class="dialog-footer">
      <el-col :offset="1" :span="10" class="left">
        <small>发票：</small>
        <el-switch
          v-model="isPrint"
          active-text="打印"
          inactive-text="不打印"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
        <small v-if="isPrint" class="left-pad">
          <span v-if="invoiceNo"> 当前发票号：{{ invoiceNo }}</span>
          <span v-else>当前用户名下没有可用发票</span>
        </small>
      </el-col>

      <!--使用医保扫码，但扫码失败时20230628-->
      <el-col :span="14" v-if="scanBtnVisible">
        <!--        <el-button type="primary" class="left-pad" @click="toScanCode"-->
        <!--          >刷医保码</el-button-->
        <!--        >-->
        <el-button class="left-pad" @click="cancel" :loading="paying">
          取 消</el-button
        >
      </el-col>

      <!--支付失败时-->
      <el-col :span="14" v-else-if="payFailFlag">
        <el-button class="left-pad" @click="cancel" :loading="paying">
          取 消</el-button
        >
      </el-col>

      <!--医保扫码不是进行中-->
      <el-col :span="14" v-else v-show="!scanPending">
        <!--不是使用医保支付-->
        <template v-if="!isUseScanPay">
          <el-button
            v-if="setting.ifMedicallnsurance && !freeItem"
            type="primary"
            class="left-pad"
            @click="medReader('1')"
            :loading="paying"
            :disabled="medable"
          >
            医保结算
          </el-button>
          <!--<el-button v-if="setting.ifMedicallnsurance" type="primary" class="left-pad" @click="medReader('2')" :loading="paying" :disabled="medable">
            单据式结算
          </el-button>-->
          <el-button
            v-if="ifConfirm && !isMedicalInsurancePay && !payError"
            class="left-pad"
            type="warning"
            @click.native="confirm"
            :loading="paying"
            >确 认
          </el-button>
        </template>
        <el-button
          class="left-pad"
          type="primary"
          :disabled="!payable"
          @click.native="settle"
          :loading="paying"
          >结 算
        </el-button>
        <el-button class="left-pad" @click="cancel" :loading="paying">
          取 消</el-button
        >
      </el-col>
    </el-row>
    <el-dialog
      custom-class="med-analysis-dialog"
      :visible.sync="medAnalysis.visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="920px"
      append-to-body
    >
      <div slot="title" class="med-analysis-title">
        <span class="med-analysis-logo">CHS</span>
        <span>事中提醒</span>
      </div>
      <div class="med-analysis-body">
        <div class="med-analysis-summary">
          提醒金额合计：{{ medAnalysisTotalAmount }} 元
        </div>
        <el-table
          :data="medAnalysis.items"
          border
          class="med-analysis-table"
          empty-text="暂无提醒"
        >
          <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
          />
          <el-table-column label="严重等级" width="95" align="center">
            <template slot-scope="{ row }">
              <i
                class="el-icon-bell med-analysis-bell"
                :class="`med-analysis-bell--${row.sev_deg || '3'}`"
                :title="sevDegText(row.sev_deg)"
              ></i>
            </template>
          </el-table-column>
          <el-table-column
            prop="rule_name"
            label="规则名称"
            min-width="220"
            show-overflow-tooltip
          />
          <el-table-column label="提醒金额" width="112" align="right">
            <template slot-scope="{ row }">
              {{ formatMedAnalysisAmount(row.vola_amt) }} 元
            </template>
          </el-table-column>
          <el-table-column
            prop="vola_cont"
            label="提醒信息"
            min-width="320"
            show-overflow-tooltip
          />
        </el-table>
      </div>
      <div class="med-analysis-remark">
        <span>备注</span>
        <el-input
          v-model="medAnalysis.remark"
          type="textarea"
          :rows="2"
          maxlength="500"
          show-word-limit
          placeholder="如需继续执行，请说明原因。"
        />
      </div>
      <div slot="footer" class="med-analysis-footer">
        <div class="med-analysis-actions">
          <el-button
            type="primary"
            :loading="medAnalysis.loadingAction === 'back'"
            :disabled="!!medAnalysis.loadingAction"
            @click="handleMedAnalysisBack"
          >
            返回修改
          </el-button>
          <el-button
            :loading="medAnalysis.loadingAction === 'continue'"
            :disabled="!!medAnalysis.loadingAction"
            @click="handleMedAnalysisContinue"
          >
            继续执行
          </el-button>
        </div>
      </div>
    </el-dialog>
    <med-reader
      v-if="reg"
      :visible.sync="showMedReader"
      show-mdtrtinfo
      :patient-id="reg.patientId"
      @ok="medSettle"
    ></med-reader>
  </el-dialog>
</template>

<script>
import api from "./api";
import commonApi from "@/common/api.js";
import { mapGetters } from "vuex";
// import scanCodeMixin from "../_medcom/scanCodeMixin"; // 为调用 this.scanCode
const MED_ANALYSIS_TEST_RESPONSE = {
  output: {
    result: [
      {
        judge_result_detail_dtos: [
          {
            vola_item_type: "1",
            mdtrt_id: "MZ260530818948",
            jrd_id: "45c27672199f4f6e9f29c1d782403696",
            patn_id: "441",
            rx_id: "JC260602002587D5",
            vola_amt: 50.0,
          },
        ],
        rule_id: "440000202605161138131000554005",
        vola_evid: "",
        mdtrt_id: "MZ260530818948",
        rule_name: "单次就诊诊疗项目与患者性别不符_事前提醒（广州）",
        vola_amt_stas: "1",
        jr_id: "58ee46df4c86488da4255cc533080425",
        patn_id: "441",
        sev_deg: "2",
        vola_amt: 50.0,
        vola_bhvr_type: "2",
        vola_cont:
          "参保人当前信息显示性别为：女,【总前列腺特异性抗原测定(TPSA)-化学发光法/总前列腺特异性抗原测定(TPSA)-化学发光法】为男性专用项目",
      },
    ],
  },
};

export default {
  // mixins: [scanCodeMixin],
  computed: {},
  props: {
    visible: Boolean,
    feeReceipt: Object,
    // 是否为免单项目
    freeItem: {
      type: Boolean,
      default: false,
    },
    // printAfterPayment: { // 是否支付后执行打印（用于挂号时）
    //   type: Boolean,
    //   default: false
    // }
  },
  components: {
    "pre-account": () => import("@/components/_medcom/preAccount"),
  },
  data() {
    return {
      payment: {},
      isPrint: false,
      invoiceNo: null,
      payWay: "cash",
      cash: null,
      loading: false, // 预结算状态
      paying: false, //支付状态
      payCode: null, //授权码
      payError: false, //支付异常
      err: null,
      reg: null,
      ifEnterprise: false,
      enterprise: null,
      rebateType: null,
      paywayable: false,
      showMedReader: false,
      rps: [],
      medSellteInfo: null,
      medPsn: null,
      setlType: null,
      activeNames: "reg",
      payFailFlag: false, // 20230621，支付方式为“支付平台”，授权码错误时，黄勤说不能出现“确定”按钮
      scanBtnVisible: false, // 刷医保码 按钮是否展示20230628
      scanPayPara: null, // 刷医保码支付需要用到
      outputSetlinfo: null, // 刷医保码支付需要用到
      isUseScanPay: false, // 是否刷医保码支付，用于判断 按钮
      scanPending: false, // 刷医保码进行中
      isMedicalInsurancePay: false, // 是否刷医保支付（用于判断显不显示“确定”按钮）
      medAnalysis: {
        visible: false,
        items: [],
        remark: "",
        medCode: "",
        tradeCode: "3103",
        header: {},
        resolve: null,
        loadingAction: "",
      },
      iFMiddleAnalysis: false, // 是否启用医保明细审核事前分析服务
    };
  },
  computed: {
    ...mapGetters([
      "token",
      "theme",
      "dict",
      "Enum",
      "setting",
      "readCardRawData",
      "user",
    ]),
    printable() {
      if (this.isPrint) {
        if (this.invoiceNo) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    change() {
      if (!this.payment) {
        return "";
      }
      if (
        this.cash &&
        !isNaN(this.cash) &&
        this.cash * 1 >= this.payment.feeCash * 1
      ) {
        return `￥${(this.cash * 1 - this.payment.feeCash * 1).toFixed(2)}`;
      } else {
        return `欠费：￥${(
          this.cash * 1 -
          (this?.payment?.feeCash * 1 || 0)
        ).toFixed(2)}`;
      }
    },
    payable() {
      if (!this.payment) {
        return false;
      }
      if (this.err && !this.payError) {
        return false;
      }
      if (this.payWay != "cash") {
        return true;
      }
      if (this.change.startsWith("欠费")) {
        return false;
      }
      return true;
    },
    ifConfirm() {
      return this.err && this.payWay !== "cash";
    },
    discountType() {
      if (
        this.feeReceipt.regs &&
        !this.feeReceipt.drugRps &&
        !this.feeReceipt.herbalRps &&
        !this.feeReceipt.miApps &&
        !this.feeReceipt.mlApps &&
        !this.feeReceipt.therapyApps
      ) {
        return this.Enum.DiscountType.挂号;
      } else {
        return this.Enum.DiscountType.门诊;
      }
    },
    payWayOptions() {
      const options = this.$utils.clone(this.dict.PayWay);
      if (!this.ifEnterprise || this.rebateType) {
        options.forEach((item) => {
          if (item.code === "enterprise") {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
      }
      return options;
    },
    medable() {
      if (this.payment.ifInsurancePaid) return true;
      else if (!this.payment.ifInsurancePaid && this.payment.feeCash <= 0)
        return true;
      else if (this.payWay == "enterprise") return true;
      return this.loading;
    },
    medAnalysisTotalAmount() {
      const total = this.medAnalysis.items.reduce((sum, item) => {
        return sum + Number(item.vola_amt || 0);
      }, 0);
      return total.toFixed(2);
    },
  },
  created() {},
  methods: {
    freeItemTip() {
      // 免单：PW07
      if (
        this.payment.feeCash > 0 &&
        this.freeItem &&
        !this.payWay.startsWith("PW07")
      ) {
        this.$message({
          type: "warning",
          message: "该项目目前为免单项目！",
          showClose: true,
          duration: 5000,
        });
        return true;
      } else {
        return false;
      }
    },
    open() {
      this.activeNames = "reg";
      this.medSellteInfo = null;
      this.payment = {};
      this.cash = null;
      this.err = null;
      this.payError = false;
      this.loading = false;
      this.payCode = null;
      this.paying = false;
      this.payWay = ""; // cash 20230302因前台需求调整，不默认
      this.reg = this?.feeReceipt?.regs[0];
      this.enterprise = this.feeReceipt.enterprise;
      this.rebateType = null;
      this.paywayable = false;
      if (!this.reg) {
        return;
      }
      this.verifyEnterprise();
      api
        .invoiceCurrent()
        .then((res) => {
          this.invoiceNo = res;
        })
        .catch((err) => {
          this.$message.warning(`获取发票号失败！${err.message || err}`);
        });

      this.loading = true;
      api
        .chgPrepare(this.feeReceipt)
        .then((paraDivide) => {
          this.rps = paraDivide.rps;
          return api.chgDivide(paraDivide);
        })
        .then((res) => {
          this.payment = res;
        })
        .catch((err) => {
          this.payment.feeCash = 0;
          this.showErr("预分解失败", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    verifyEnterprise() {
      // 患者是企业用户
      if (this.enterprise) {
        try {
          // 并且在有效期内，默认选中企业支付
          api
            .getUsableByPat(this.reg.patientId, { type: this.discountType })
            .then((res) => {
              if (res != "true") return;
              // 判断挂号是否是企业支付，如果是门诊缴费只能使用企业支付，如果不是门诊将不能使用企业支付
              if (
                this.reg.paymentState === this.Enum.PaymentState.未支付 ||
                (this.reg.paymentState !== this.Enum.PaymentState.未支付 &&
                  this.reg.enterpriseCode)
              ) {
                this.paywayable = true;
                this.payWay = "enterprise";
                this.ifEnterprise = true;
              }
            });
        } catch (error) {
          this.$utils.log(error);
        }
      }
    },
    async cancel() {
      // 医保交易成功，需要调用冲正交易
      const success = await this.medImpact();
      if (!success) {
        return;
      }

      api
        .chgCancel(this.reg.patientId)
        .then((res) => {
          return api.chgClearPrepare(this.reg.patientId);
        })
        .then((res) => {
          this.$emit("cancel");
          this.$emit("update:visible", false);
          this.afterCloseResetState();
        });
    },
    result() {
      if (!this.payment.payWay) this.payment.payWay = this.payWay; // R防止payWay为null
      // if (this.printAfterPayment) {
      //   this.printReceipt(this.reg, this.payment); // 来源 printMixin.js
      // }
      this.$emit("paid", this.payment);
      if (this.isPrint) {
        api.invoiceNext();
      }
      this.$message.success("结算成功!");
      this.$emit("update:visible", false);
      this.afterCloseResetState();
    },
    settle() {
      if (this.freeItemTip()) return;
      console.log("this.payWay: ", this.payWay);

      if (!this.payWay) {
        this.$message.warning("请选择支付方式");
        return;
      }
      if (!this.payable || !this.printable) {
        return;
      }
      if (this.paying) {
        return;
      }
      if (!this.payment.id) {
        return;
      }
      this.paying = true;
      this.err = null;
      this.payError = false;
      const invoiceNo = this.isPrint ? this.invoiceNo : null;
      const para = {
        ...this.payment,
        payWay: this.payWay,
        payCode: this.payCode,
        invoiceNo: invoiceNo,
      };
      console.log(
        "医保基金支付",
        this.medSellteInfo?.setlinfo?.fund_pay_sumamt
      );
      api
        .chgExec(this.payment.id, para)
        .then((res) => {
          this.payment = res;
          res.rebateType = this.rebateType;
          return api.chgUpdate(res);
        })
        .then((res) => {
          return api.chgFinish(this.payment.id);
        })
        .then((res) => {
          this.result();
        })
        .catch((err) => {
          this.payError = true;
          if (err.message) {
            this.showErr("支付失败！", err.message);
            // 20230621，加以下4行
            if (this.payCode) {
              this.payFailFlag = true;
              this.payCode = "";
            }
          } else {
            this.showErr(
              "等待患者输入密码。。",
              "支付成功后，点击“确认”操作。"
            );
          }
        })
        .finally(() => {
          this.paying = false;
        });
    },
    showErr(tip, err) {
      this.err = `${tip}。${err.message || err}`;
      this.$message.error(this.err);
    },
    confirm() {
      this.payError = false;
      if (!this.payment.id) {
        return;
      }
      api
        .chgUpdateState({ paymentId: this.payment.id })
        .then((res) => {
          this.$utils.log(res);
          if (res.state === "已执行" && res.payWaySerialNo) {
            this.feeReceipt.payment = res;
            return api.chgUpdate(this.feeReceipt);
          }
          this.showErr("确认失败", `订单状态为${res.state}`);
        })
        .then((res) => {
          api.chgFinish(this.payment.id);
          this.result();
        })
        .catch((err) => {
          this.showErr("查询支付订单失败", err);
        })
        .finally(() => {
          this.result();
        });
    },
    payWayChange(val) {
      if (val === "enterprise") {
        this.rebateType = null;
      }
    },
    rebateTypeChange(val, row) {
      if (val && row) {
        const feeCash = this.$utils.fmtFloat(
          this.payment.feeAmount * row.ratio,
          2
        );
        this.payment.feeDiscount = parseFloat(
          this.$utils.fmtFloat(feeCash - this.payment.feeAmount, 2)
        );
        this.payment.feeCash = parseFloat(feeCash);
      } else {
        this.payment.feeDiscount = 0;
        this.payment.feeCash = this.payment.feeAmount;
      }
    },
    /**************************** 医保结算 **************************/
    medReader(key) {
      if (!this.setting.ifMedicallnsurance) {
        this.$message.warning("未启用医保！");
        return;
      }
      this.showMedReader = true;
      if (key == "1") {
        this.setlType = "门诊结算";
      } else if (key == "2") {
        this.setlType = "门诊单据式结算";
      }
    },
    // 医保冲正
    async medImpact() {
      if (!this.medSellteInfo) return true;
      const ok = await this.$confirm(
        "当前医保已结算，取消医保将执行退款，确认不结算并执行退款操作？",
        "取消确认"
      ).catch((err) => {
        return false;
      });
      if (!ok) {
        return false;
      }
      const header = {
        insuplc_admdvs: this.medPsn.insuinfo.insuplc_admdvs,
        ip: this.medPsn.readCard.ip,
        mac: this.medPsn.readCard.mac,
      };
      if (this.setlType === this.Enum.SetlType.门诊单据式结算) {
        const para = {
          header: header,
          input: {
            setlId: this.medSellteInfo.setlinfo.setl_id,
            setlIdDelIf: "true",
          },
        };
        // 单据是结算撤销
        const msg = await api
          .medDtRefund(this.medPsn.med_code, para)
          .catch((err) => {
            return err;
          });
        if (msg && msg.message) {
          this.$message.error(`医保冲正交易失败：${msg.message}！`);
          return false;
        } else {
          this.$message.success("门诊医保结算撤销成功！");
          return true;
        }
      }
      if (this.setlType === this.Enum.SetlType.门诊结算) {
        const para = {
          header: header,
          input: {
            psnNo: this.medPsn.baseinfo.psn_no,
            msgId: this.medSellteInfo.msgId,
            rpNo: this.rps.map((item) => item.no),
          },
        };
        // 冲正
        const msg = await api
          .medImpact(this.medPsn.med_code, para)
          .catch((err) => {
            return err.message || err;
          });
        if (msg?.infcode === 0) {
          this.$message.success(msg.warn_msg);
          return true;
        } else {
          this.$message.error(`医保冲正交易失败：${msg}！`);
          return false;
        }
      }
    },
    // 关闭层，还原多个状态，一定要重置，因为关闭弹窗后，组件不卸载，会保留旧状态20230628
    afterCloseResetState() {
      this.payFailFlag = false;
      this.scanBtnVisible = false;
      this.scanPending = false;
      this.isUseScanPay = false;
      this.outputSetlinfo = null;
    },
    // 结算，来自“医保电子凭证"，也就是扫医保码(20230628)。唤起扫码扫码蹲，codeData二次扫医保电子码返回值
    medSettleByScanCode(codeData, header, input, setlinfo) {
      const payload = {
        header,
        input: {
          medfeeSumamt: setlinfo.medfee_sumamt, // 医疗费总额
          mdtrtId: setlinfo.mdtrt_id,
          acctUsedFlag: setlinfo.acct_used_flag,
          psnSetlway: setlinfo.psn_setlway,
          chrgBchno: "", // 收费批次号（非必填）
          orderNo: "", // 医院订单号（非必填）
          invono: "", // 发票号
          midSetlFlag: 0, // 中途结算标志
          mdtrtCertType: codeData.mdtrt_cert_type, // 一定是取自二次扫医保电子码的值，而非input.mdtrt_cert_type
          mdtrtCertNo: codeData.mdtrt_cert_no, // 一定是取自二次扫医保电子码的值，而非input.mdtrt_cert_no
          psnNo: input.psn_no,
          insutype: input.insutype,
          medType: input.med_type,
          mdtrtMode: input.mdtrt_mode,
          hcardBasinfo: input.hcard_chkinfo,
          hcardChkinfo: input.hcard_chkinfo,
        },
      };
      // console.log('医保二次扫码后', codeData, '预结算接口返回', setlinfo);
      // console.log(9999, payload);
      api
        .medCorpuscleRegistered(this.$store.state.medCode, payload)
        .then((response) => {
          this.medSellteInfo.msgId = response.msgId;
          this.$message.success("电子医保结算成功！");
          this.scanBtnVisible = false;
          this.scanPending = false;
          console.log(
            6666,
            "医保成功了",
            response,
            this.scanBtnVisible,
            this.scanPending
          );
          this.setVal(response.output);
        })
        .catch((err) => {
          this.scanBtnVisible = true;
          this.$message({
            type: "error",
            message: err.message || err,
            showClose: true,
            duration: 15000,
          });
        })
        .finally(() => (this.isUseScanPay = false));
    },
    async buildMedAnalysisParams(val, rps) {
      const headerVal = val?.header || {
        insuplc_admdvs: val?.insuinfo?.insuplc_admdvs || "440104",
      };
      return {
        header: headerVal,
        trigScen: "6",
        // trigScen: "2",
        medMdtrtType: "1",
        patientId: this.reg.patientId,
        opNo: this.reg.opNo,
        // medinsType: "A2",
        reimFlag: "0",
        insutype: val?.insuinfo?.insutype || this.reg.insuranceType || "310",
        rpNos: rps.map((item) => item.no).filter((no) => no),
        medType: val?.med_type || "11",
      };
    },
    getMedAnalysisItems(result) {
      const items = result?.output?.result;
      if (Array.isArray(items) && items.length) {
        return items;
      }
      return [];
      //for test
      // return MED_ANALYSIS_TEST_RESPONSE.output.result;
    },
    /**
     * 开始处理医保逻辑
     */
    async doMedAnalysisFun(val) {
      const medAnalysisRes = await commonApi.getSetting({
        sysCode: cfg.sys.code,
        code: "iFMiddleAnalysis",
      });
      if (Array.isArray(medAnalysisRes.items) && medAnalysisRes.items[0]) {
        this.iFMiddleAnalysis = medAnalysisRes.items[0]?.value === "true";
      } else {
        this.iFMiddleAnalysis = false;
      }
      // 医保明细审核事前分析服务
      if (val?.insuinfo?.insutype && this.iFMiddleAnalysis) {
        try {
          const result = await this.execMedAnalysis(val);
          if (result === "back") {
            return false;
          }
        } catch (err) {
          this.$message.error(err.message || err);
          console.log("execMedAnalysis err: ", err);
          return false;
        }
      }
      return true;
    },
    /**
     * 调用接口查询医保明细审核事中分析
     * @param val
     */
    async execMedAnalysis(val) {
      const params = await this.buildMedAnalysisParams(val, this.rps);
      const medCode = val?.med_code || this.$store.state.medCode || "020";
      const result = await api.queryMedAnalysis(medCode, "3101", params);
      //for test
      // const result = null;
      const items = this.getMedAnalysisItems(result);
      console.log("getMedAnalysisItems items: ", items);
      if (!items.length) {
        return "continue";
      }
      return await this.showMedAnalysisDialog({
        medCode,
        tradeCode: "3103",
        header: params.header,
        items,
      });
    },
    showMedAnalysisDialog({ medCode, tradeCode, header, items }) {
      this.medAnalysis.visible = true;
      this.medAnalysis.items = items;
      this.medAnalysis.remark = "";
      this.medAnalysis.medCode = medCode;
      this.medAnalysis.tradeCode = tradeCode;
      this.medAnalysis.header = header || {};
      this.medAnalysis.loadingAction = "";
      return new Promise((resolve) => {
        this.medAnalysis.resolve = resolve;
      });
    },
    async submitMedAnalysisFeedback(action) {
      const actionText = action === "back" ? "返回修改" : "继续执行";
      const payload = {
        warn_type: "1",
        warns: this.medAnalysis.items.map((item) => {
          return {
            warn_rslt_id: item.jr_id,
            dspo_way: action === "back" ? "2" : "1",
            dspo_way_rea: this.medAnalysis.remark || actionText,
          };
        }),
        header: this.medAnalysis.header,
      };
      await api.queryMedAnalysisFeedback(
        this.medAnalysis.medCode,
        this.medAnalysis.tradeCode,
        payload
      );
    },
    resolveMedAnalysis(action) {
      const resolve = this.medAnalysis.resolve;
      this.medAnalysis.visible = false;
      this.medAnalysis.resolve = null;
      this.medAnalysis.loadingAction = "";
      if (resolve) {
        resolve(action);
      }
    },
    async handleMedAnalysis(action) {
      if (this.medAnalysis.loadingAction) {
        return;
      }
      if (action === "continue" && !this.medAnalysis.remark) {
        this.$message.warning("请输入继续执行的原因");
        return;
      }
      this.medAnalysis.loadingAction = action;
      try {
        // for test
        await this.submitMedAnalysisFeedback(action);

        this.resolveMedAnalysis(action);
      } catch (err) {
        this.medAnalysis.loadingAction = "";
        this.$message.error(err.message || err);
      }
    },
    handleMedAnalysisBack() {
      this.handleMedAnalysis("back");
    },
    handleMedAnalysisContinue() {
      this.handleMedAnalysis("continue");
    },
    formatMedAnalysisAmount(value) {
      return Number(value || 0).toFixed(2);
    },
    sevDegText(value) {
      const map = {
        1: "明确违规",
        2: "高度可疑",
        3: "轻度可疑",
      };
      return map[value] || "";
    },
    // 结算
    medSettle(val) {
      // console.log('选中人员信息medSettle==========>', val);
      console.log("刷医保的人员身份===", val, val.readCard);
      // 校验医保支付时，医保卡持有人与就诊是同一人20230624
      // if (process.env.NODE_ENV !== "development") return;
      api
        .medCardCheckoutUser({
          idNo: val.certno,
          patientId: this.reg.patientId,
        })
        .then(async (data) => {
          if (data === "true") {
            const success = await this.doMedAnalysisFun(val);
            if (success) {
              // for test
              // if (1 == 1) {
              //   this.$message.error("测试拦截支付");
              //   return;
              // }
              this.toMedSettle(val);
            }
          } else {
            this.$message.error("医保卡持有人与就诊人不是同一人，不能医保支付");
          }
        });
    },
    // 结算
    toMedSettle(val) {
      this.medPsn = val;
      const dept = this.dict.Dept.find((t) => t.code === this.reg.deptCode);
      const { pOutInfo, signBuffInfo, mdtrt_cert_type, certno } =
        this.$store.state.readCardRawData.pOutInfo;
      const para = {
        header: {
          insuplc_admdvs: val.insuinfo.insuplc_admdvs,
          ip: "10.10.21.175",
          mac: "4C-03-4F-58-66-A5",
        },
        input: {
          rpNo: this.rps.map((item) => item.no),
          ifRegistered: this.discountType == "挂号",
          paymentId: this.payment.id,
          ipt_otp_no: this.reg.opNo,
          caty: dept.standardDeptCode,
          med_type: val.med_type,
          psn_no: val.baseinfo.psn_no,
          insutype: val.insuinfo.insutype,
          mdtrt_cert_type,
          mdtrt_cert_no: certno,
          // hcard_basinfo: val.readCard.hcard_basinfo,
          // hcard_chkinfo: val.readCard.hcard_chkinfo,
          // hcard_basinfo: val.readCard.orgin_card_info || "", // 20230508因黄勤需求而添加，异地医保时，hcard_basinfo需要传值
          // hcard_chkinfo: val.readCard.sign || "", // 20230508因黄勤需求而添加

          // 德卡
          hcard_basinfo: pOutInfo,
          hcard_chkinfo: signBuffInfo,
          dise_codg: val.dise_codg,
          dise_name: val.dise_name,
          birctrl_type: val.birctrl_type,
          birctrl_matn_date: val.birctrl_matn_date,
          ttp_resp: val.ttp_resp,
          expi_gestation_nub_of_m: val.expi_gestation_nub_of_m,
          rx_circ_flag: val.rx_circ_flag,
          matn_fee_flag: val.matn_fee_flag,
          psn_setlway: val.psn_setlway,
          acct_used_flag: val.acct_used_flag,
          mdtrt_mode: val.mdtrt_mode,
          // matn_type: val.matn_type
        },
      };
      console.log(
        "预支付payload=",
        val.readCard.orgin_card_info,
        val.readCard,
        para
      );
      this.paying = true;
      let apiFn = api.medSellte;
      if (this.setlType === this.Enum.SetlType.门诊单据式结算) {
        apiFn = api.medDtSellte;
      }
      apiFn(val.med_code, para)
        .then((res) => {
          this.medSellteInfo = res.output;
          this.medSellteInfo.msgId = res.msgId;
          this.activeNames = "med_setl";
          // console.warn(4004, 'mdtrt_cert_type=', val.readCard.mdtrt_cert_type, this.entity);
          if (val.readCard.mdtrt_cert_type !== "01") {
            this.$message.success("医保结算成功！");
            this.isMedicalInsurancePay = true;
            this.setVal(res.output);
          } else {
            console.warn(
              4004,
              "mdtrt_cert_type=",
              val.readCard.mdtrt_cert_type,
              val,
              this.entity
            );
            console.warn(4005, "res=", res);
            this.setVal(res.output);
            // this.scanPayPara = para;
            // this.outputSetlinfo = {
            //   ...res.output.setlinfo,
            //   acct_used_flag: val.acct_used_flag,
            // }
            // this.isUseScanPay = true;
            // // console.warn(40005, '再次唤起医保扫码', this.entity, this.outputSetlinfo);
            // this.toScanCode();
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message || err,
            showClose: true,
            duration: 15000, // 15秒
          });
        })
        .finally(() => {
          this.paying = false;
        });
    },
    // 再次唤起医保扫码
    toScanCode() {
      const para = this.scanPayPara;
      this.scanPending = true;
      // 医信逻辑
      // this.scanCode(
      //   (data) => {
      //     this.scanBtnVisible = false;
      //     this.medSettleByScanCode(
      //       data,
      //       para.header,
      //       para.input,
      //       this.outputSetlinfo
      //     );
      //   },
      //   () => {
      //     this.scanBtnVisible = true;
      //     this.scanPending = false;
      //   }
      // );
      try {
        const { ecToken, idNo, idType, userName } =
          this.$store.state.readCardRawData.pOutInfo;
        const data = {
          mdtrt_cert_type: "01",
          mdtrt_cert_no: ecToken,
          certno: idNo,
          orgin_card_info: "",
          sign: "",
          card_sn: "",
          begntime: "",
          psn_cert_type: idType,
          psn_name: userName,
        };
        this.scanBtnVisible = false;
        this.medSettleByScanCode(
          data,
          para.header,
          para.input,
          this.outputSetlinfo
        );
      } catch (e) {
        console.log("pay toScanCode error", e);
        this.scanBtnVisible = true;
        this.scanPending = false;
      }
    },
    setVal(res) {
      if (!res.setlinfo) return;
      this.$set(this.payment, "insuranceNo", res.setlinfo.psn_no);
      this.$set(this.payment, "feeAccount", res.setlinfo.acct_pay);
      this.$set(this.payment, "feeFund", res.setlinfo.fund_pay_sumamt);
      if (this.setlType == "门诊结算") {
        this.$set(this.payment, "feeCash", res.setlinfo.psn_cash_pay);
      } else {
        const feeCash = parseFloat(
          this.$utils.fmtFloat(
            res.setlinfo.medfee_sumamt -
              res.setlinfo.fund_pay_sumamt -
              res.setlinfo.acct_pay,
            2
          )
        );
        this.$set(this.payment, "feeCash", feeCash);
      }
      this.$set(this.payment, "insuranceDate", res.setlinfo.setl_time);
      this.$set(this.payment, "ifInsurancePaid", true);
      this.$set(this.payment, "insuranceSerialNo", res.setlinfo.setl_id);
      this.$set(this.payment, "mdtrtId", res.setlinfo.mdtrt_id);
      this.$set(this.payment, "setlType", this.setlType);
      this.$set(this.payment, "feeDiscount", 0);
      this.rebateType = null;
    },
  },
};
</script>

<style scoped>
.red {
  color: red;
}

.orange {
  color: orangered;
}

.medium {
  font-size: 3rem;
}

.mini {
  font-size: 0.8rem;
}

.flex {
  width: 15rem;
  display: flex;
  height: 3rem;
  padding: 0rem 2rem 0rem 2rem;
  justify-content: space-between;
  align-items: center;
}

.top-pad {
  margin-top: 0.8rem;
}

.invoice {
  font-size: 1.5rem;
}

.med-analysis-title {
  height: 42px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 4px;
  color: #fff;
  font-size: 17px;
  font-weight: 700;
}

.med-analysis-logo {
  width: 34px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 13px;
  font-weight: 700;
}

.med-analysis-body {
  padding: 16px 24px 26px;
}

.med-analysis-summary {
  margin-bottom: 18px;
  padding: 18px 24px;
  background: #f5f5f5;
  color: #333;
  font-size: 16px;
  font-weight: 700;
}

.med-analysis-table {
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;
}

.med-analysis-bell {
  font-size: 24px;
}

.med-analysis-bell--1 {
  color: #f5222d;
}

.med-analysis-bell--2 {
  color: #ff9f43;
}

.med-analysis-bell--3 {
  color: #ffd600;
}

.med-analysis-footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 24px 16px;
}

.med-analysis-actions {
  text-align: right;
}
.med-analysis-remark {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.med-analysis-remark > span {
  flex: 0 0 42px;
  color: #333;
  font-weight: 700;
}

.med-analysis-remark .el-textarea {
  flex: 1;
}

/deep/ .med-analysis-dialog .el-dialog__header {
  padding: 0 24px;
  background: #1f67b7;
}

/deep/ .med-analysis-dialog .el-dialog__body {
  padding: 0;
}

/deep/ .med-analysis-dialog .el-dialog__footer {
  padding: 0;
}
</style>
